export default __webpack_public_path__ + "88eb49901ff063d65a035dd7a2da5757.png";